module.exports = __webpack_public_path__ + "static/media/Air Conditioning.4080d623.svg";